import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderOverviewComponent } from './order-overview/order-overview.component';
import { OrderDetailsComponent } from './order-details/order-details.component';

const routes: Routes = [
  {
    path: 'order-history',
    component: OrderOverviewComponent
  },
  {
    path: 'order-history/:id',
    component: OrderDetailsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderHistoryRoutingModule { }
